import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQuery, useParameterizedQuery } from 'react-fetching-library';
import { getEmployeeApplications, createApplicationBasedOnEmployeeData, updateEmployeeConfigAction } from '../../../services/request';
import ApplicationForm from './applicationForm/ApplicationForm';
import { useLocation, useNavigate } from 'react-router';

import { ApplicationsColumns } from '../../../services/column-definitions';

import { setEAOrderColumnsWidth, setEAOrderColumnsSequence } from '../../../services/redux-actions';

import toast from 'react-hot-toast';

const ApplicationsContext = React.createContext();

export function useApplication() {
  return useContext(ApplicationsContext);
}

export default function ApplicationsProvider({ children, applicationId }) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { eaColumnsWidth, eaColumnsSequence } = useSelector(state => state.employeeRecruitmentConfig);
  const { employeeId, employeeConfigId } = useSelector(state => state.app);
  const [search, setSearch] = useState(null);
  const [filtersParams, setFiltersParams] = useState(null);
  const { loading, payload, error, query } = useQuery(getEmployeeApplications('GET', null, search, filtersParams));
  const { loading: optionsLoading, payload: optionsPayload, error: optionsError } = useQuery(getEmployeeApplications('OPTIONS'));
  const { mutate } = useMutation(createApplicationBasedOnEmployeeData);
  const { mutate: configMutate } = useMutation(updateEmployeeConfigAction);
  const { query: getApplicationDetails } = useParameterizedQuery(getEmployeeApplications);
  const [application, setApplication] = useState({});
  const [applications, setApplications] = useState([]);
  const [choices, setChoices] = useState({});
  const [state, setState] = React.useState(application.state);
  const [columns, setColumns] = React.useState(ApplicationsColumns());

  const createNewApplicationBasedOnEmployeeData = async () => {
    const { error, payload } = await mutate(location.state.employeeData);
    if (!error) {
      setApplication(payload);
      setState(payload.state);
      navigate('.', { replace: true }); // <-- redirect to current path w/o state
    } else {
      console.error('err2');
      navigate('.', { replace: true });
    }
  };

  const getDetails = async id => {
    const { payload, loading, error } = await getApplicationDetails('GET', id);

    if (!error && !loading) {
      return payload;
    }

    if (error) {
      toast.error('Nie udało się pobrać danych pracownika');
    }

    return {};
  };

  useEffect(async () => {
    if (!error && !loading) {
      setApplications(payload.results);
      // applicationId jest obecny gdy otwieramy nową kartę w panelu pracownika

      if (!_.isNil(applicationId)) {
        const { payload, loading, error } = await getApplicationDetails('GET', applicationId);
        if (!error && !loading) {
          setApplication(payload);
          setState(payload.state);
        }
      }

      // const app = _.filter(payload.results, app => app.id == applicationId);

      // if (app.length > 0) {
      //   setApplication(app[0]);
      //   setState(app[0].state);
      // }

      // locationState jest obecny gdy tworzymy nową aplikacje z panelu pracownika
      if (location.state && location.state.employeeData) {
        createNewApplicationBasedOnEmployeeData();
      }
    }
  }, [loading]);

  useEffect(() => {
    if (!optionsError && !optionsLoading) {
      setChoices(optionsPayload.actions.GET.choices);
    }
  }, [optionsLoading]);

  useEffect(async () => {
    // const app = _.filter(applications, app => app.id == applicationId);
    // if (app.length > 0) {
    //   setApplication(app[0]);
    //   setState(app[0].id);
    // }
    if (!_.isNil(applicationId)) {
      const { payload, loading, error } = await getApplicationDetails('GET', applicationId);
      if (!error && !loading) {
        setApplication(payload);
        setState(payload.state);
      }
    }
  }, [applicationId]);

  useEffect(() => {
    if (application !== undefined && Object.keys(application).length !== 0) {
      setState(application.state);
    }
  }, [application]);


  const handleChangeStateCallback = newState => {
    setState(newState);
  };

  const handleColumnWidthChange = async colDef => {
    const { payload } = dispatch(setEAOrderColumnsWidth({ ...eaColumnsWidth, [colDef.field]: colDef.width }));
    await configMutate({ ea_columns_width: payload, employee: employeeId }, employeeConfigId);
  };

  const handleColumnsOrderChange = async columns => {
    const { payload } = dispatch(setEAOrderColumnsSequence(columns));
    await configMutate({ ea_columns_sequence: payload, employee: employeeId }, employeeConfigId);
  };

  useEffect(() => {
    setColumns(prev => prev.map(c => {
      if (c.field in eaColumnsWidth) {
        return { ...c, width: eaColumnsWidth[c.field] };
      }

      return c;
    }));
  }, [eaColumnsWidth]);

  useEffect(() => {
    setColumns(prev => [...prev].sort((a, b) => eaColumnsSequence.indexOf(a.field) - eaColumnsSequence.indexOf(b.field)));
  }, [eaColumnsSequence]);

  return (
    <ApplicationsContext.Provider value={
      {
        rowData: application,
        setRowData: setApplication,
        rows: applications,
        setRows: setApplications,
        columns,
        handleColumnWidthChange,
        handleColumnsOrderChange,
        getDetails,
        setSearch,
        setFiltersParams,
        choices,
        loading,
        query,
        error,
        handleChangeStateCallback,
        state,
        detailDialog: <ApplicationForm/>
      }
    }>
      {children}
    </ApplicationsContext.Provider>
  );
};
